import { useEffect, useRef } from 'react';

import { subscribeForegroundMessage } from '../../../firebase';
import { INotification } from './WapperNotification';

export interface FcmMsg extends INotification {
  idPhieu?: string;
  maPhieu?: string;
}

const SW_URL = './firebase-messaging-sw.js';

// Đăng ký service worker đúng 1 lần cho cả app
let swRegPromise: Promise<ServiceWorkerRegistration> | null = null;
const registerSW = () => {
  if (!('serviceWorker' in navigator)) return null;
  if (!swRegPromise) {
    swRegPromise = navigator.serviceWorker.register(SW_URL, { scope: './' }).catch(err => {
      swRegPromise = null; // cho phép thử lại lần sau
      throw err;
    });
  }
  return swRegPromise;
};

// Đẩy vào trung tâm thông báo của máy (foreground FCM không tự hiện, nên phải tự gọi)
export const showSystemNotification = async (title: string, body: string) => {
  try {
    if (Notification.permission !== 'granted') return;
    const pending = registerSW();
    if (!pending) return;
    await pending;
    const registration = await navigator.serviceWorker.ready; // chờ SW active mới showNotification được
    await registration.showNotification(title, { body });
    registration.update();
  } catch (error) {
    console.log('showSystemNotification err', error);
  }
};

const toMsg = (title: string | undefined, data: any): FcmMsg => {
  const body = data
    ? {
        ...data,
        staffBehavior: data.StaffBehavior ?? data.staffBehavior, // format lại cho dữ liệu chuẩn web dùng
        staffSend: data.UserTrigger ?? data.staffSend // format lại cho dữ liệu chuẩn web dùng
      }
    : {};
  return {
    title: title || '',
    body,
    maDonHang: body.maDonHang,
    idPhieu: body.TicketIds,
    maPhieu: body.TicketCodes
  }; // maDonHang cho đơn hàng còn
};

export function useFcmMessages(onMessage: (msg: FcmMsg) => void) {
  // luôn gọi callback mới nhất, tránh stale closure mà không phải đăng ký lại listener
  const cbRef = useRef(onMessage);
  cbRef.current = onMessage;

  useEffect(() => {
    // ===== 1. CHẠY NỀN: service worker nhận FCM rồi báo về qua BroadcastChannel =====
    const channel = new BroadcastChannel('notifications');
    const onBgMessage = (payload: MessageEvent) => {
      console.log('payload bg fcm', payload);
      const msg = toMsg(payload.data?.notification?.title, payload.data?.data);
      cbRef.current(msg);
    };
    channel.addEventListener('message', onBgMessage);

    // ===== 2. FOREGROUND: đang mở tab =====
    // onMessage trả về hàm unsubscribe nên gỡ sạch khi unmount
    const unsubscribe = subscribeForegroundMessage((payload: any) => {
      console.log('FCM foreground', payload);

      cbRef.current(toMsg(payload?.notification?.title, payload?.data));
      showSystemNotification(payload?.notification?.title || '', 'Đơn hàng cập nhật, Xem ngay****');
    });

    return () => {
      unsubscribe();
      channel.removeEventListener('message', onBgMessage);
      channel.close();
    };
  }, []);
}
